/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_DashboardInputs */

const en_admin_dashboard_dashboard = /** @type {(inputs: Admin_Dashboard_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const fr_admin_dashboard_dashboard = /** @type {(inputs: Admin_Dashboard_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableau de bord`)
};

const nl_admin_dashboard_dashboard = /** @type {(inputs: Admin_Dashboard_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const ro_admin_dashboard_dashboard = /** @type {(inputs: Admin_Dashboard_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tablou de Bord`)
};

/** @type {(inputs: Admin_Dashboard_DashboardInputs) => LocalizedString} */
const de_admin_dashboard_dashboard = en_admin_dashboard_dashboard;

/** @type {(inputs: Admin_Dashboard_DashboardInputs) => LocalizedString} */
const es_admin_dashboard_dashboard = en_admin_dashboard_dashboard;

/** @type {(inputs: Admin_Dashboard_DashboardInputs) => LocalizedString} */
const it_admin_dashboard_dashboard = en_admin_dashboard_dashboard;

/** @type {(inputs: Admin_Dashboard_DashboardInputs) => LocalizedString} */
const pt_br2_admin_dashboard_dashboard = en_admin_dashboard_dashboard;

/** @type {(inputs: Admin_Dashboard_DashboardInputs) => LocalizedString} */
const pl_admin_dashboard_dashboard = en_admin_dashboard_dashboard;

/** @type {(inputs: Admin_Dashboard_DashboardInputs) => LocalizedString} */
const hu_admin_dashboard_dashboard = en_admin_dashboard_dashboard;

/**
* | output |
* | --- |
* | "Dashboard" |
*
* @param {Admin_Dashboard_DashboardInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_dashboard = /** @type {((inputs?: Admin_Dashboard_DashboardInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_DashboardInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_dashboard(inputs)
	if (locale === "de") return de_admin_dashboard_dashboard(inputs)
	if (locale === "es") return es_admin_dashboard_dashboard(inputs)
	if (locale === "fr") return fr_admin_dashboard_dashboard(inputs)
	if (locale === "nl") return nl_admin_dashboard_dashboard(inputs)
	if (locale === "it") return it_admin_dashboard_dashboard(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_dashboard(inputs)
	if (locale === "pl") return pl_admin_dashboard_dashboard(inputs)
	if (locale === "hu") return hu_admin_dashboard_dashboard(inputs)
	return ro_admin_dashboard_dashboard(inputs)
});
export { admin_dashboard_dashboard as "admin.dashboard.dashboard" }